import { render, staticRenderFns } from "./SpaceOnboardingPage.vue?vue&type=template&id=e2a1ffc6"
import script from "./SpaceOnboardingPage.vue?vue&type=script&lang=ts"
export * from "./SpaceOnboardingPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports